import { useState } from 'react'
import { sortBy, startCase } from 'lodash-es'
import type { SearchOption } from '@jana-technology/platform-ui'

import {
  findLookupTablesFromBaseSettings,
  useGetBaseSettingsQuery
} from 'app/services/api/basesettings'
import { SelectDropdownWrapper } from 'common/components/SelectDropdownWrapper'

import { IGroupColumnsSelection } from 'features/RiskManagement/Components/Tables'

interface IThreatDropdownProps {
  setGroupColumns: (args: IGroupColumnsSelection[]) => void
  disabled?: boolean
}

interface IThreats {
  Id: number
  Name: string
  TypeCode: 'POF' | 'COF'
}
const ThreatDropdown = ({
  setGroupColumns,
  disabled = false
}: IThreatDropdownProps) => {
  const { lookupTables } = useGetBaseSettingsQuery(undefined, {
    selectFromResult: ({ data }) => ({
      lookupTables: findLookupTablesFromBaseSettings(data)
    })
  })

  const [selectedThreatValue, setSelectedThreatValue] = useState<
    string | undefined
  >()

  // REVIEW: should memoize this?
  const threatOptions: SearchOption[] = []

  lookupTables?.details.forEach((table) => {
    if (table.key === 'Threat') {
      const threats = table.value as unknown as Array<IThreats>

      threats.forEach((threat) => {
        if (threat.TypeCode === 'POF') {
          threatOptions.push({
            label: startCase(threat.Name),
            value: threat.Id.toString()
          })
        }
      })
    }
  })

  const onThreatSelection = (selection: SearchOption) => {
    if (!selection.value) {
      setGroupColumns([])
      setSelectedThreatValue(undefined)
    } else {
      const id = Number(selection.value)

      setGroupColumns([
        {
          id,
          name: selection.label?.toString() ?? '',
          groupTypeColumns: undefined
        }
      ])
      setSelectedThreatValue(selection.value as string)
    }
  }

  return (
    <div className='flex items-center'>
      <span className='font-semibold text-gray-700'>Threat</span>
      <SelectDropdownWrapper
        className='mx-2 w-64'
        disabled={disabled}
        options={sortBy(threatOptions, 'label')}
        value={selectedThreatValue}
        onChange={(_, selection) => {
          onThreatSelection(selection as SearchOption)
        }}
      />
    </div>
  )
}

export default ThreatDropdown
